<template>
  <RouterLink
    class="py-2 px-4 rounded-md transition-colors text-gray-600 hover:bg-gray-200 hover:no-underline flex gap-2 items-center"
    :class="{
      'border-2 border-dashed border-orange-500 bg-orange-100 hover:bg-orange-200 text-orange-900':
        isAdmin,
    }"
    exact-active-class="bg-gray-200 font-bold text-gray-950"
    :to="to"
  >
    <component v-if="icon" class="w-5 h-5" :is="icon"></component>
    {{ name }}
  </RouterLink>
</template>
<script setup>
defineProps({
  to: { type: [String, Object], required: true },
  icon: { type: Object, required: false },
  name: { type: String, required: true },
  isAdmin: { type: Boolean, default: false },
});
</script>
